module.exports = __webpack_public_path__ + "media/images/strategic-partners/bonita-c81672e673d35491e77612b8d5c5bbb3.jpeg";